import { useState }from 'react';
import Tooltip from "../Tooltip"
import '../../style/App.css';
import { Popover } from '@base-ui-components/react/popover';

const OptionButton = ({src, message, onClickFunction = () => {}, imgClassName='', wrapperClassName='', imgStyle={}, imgRef=null}) => {
    const [open, setOpen] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    const handleHoverOpen = () => {
        setTimeoutId(setTimeout(() => {
            setOpen(true)
        }, 500))
    }

    const handleHoverClose = () => {
        setOpen(false)
        if(timeoutId) {
            clearTimeout(timeoutId)
        }
    }
    
    return (
        <Popover.Root open={open} onOpenChange={setOpen}>
            <Popover.Trigger className='triggerButton' aschild='true'
                onMouseEnter={handleHoverOpen} 
                onMouseLeave={handleHoverClose} 
            >
                <div className={`optionWrapper ${wrapperClassName}`}>
                    <img className={`option ${imgClassName}`} style={imgStyle} src={src} alt={message} onClick={e => onClickFunction(e)} ref={imgRef}/>
                </div>
            </Popover.Trigger>
            <Popover.Portal >
                <Popover.Positioner sticky={true} side='top' sideOffset={8} style={{ zIndex: 9999 }}>
                    <Popover.Popup style={{ zIndex: 9999 }}>
                        <Tooltip message={message}/>
                    </Popover.Popup>
                </Popover.Positioner>
            </Popover.Portal>
        </Popover.Root>
    )
};
export default OptionButton;